import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
} from '@angular/core';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import { UserService } from 'src/app/services/user.service';
import { IUserNew, IUser } from 'src/app/models/user';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { ITeam } from 'src/app/models/team';
import { TeamsService } from 'src/app/services/teams.service';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { IValidationResponse } from 'src/app/models/validation-response';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { UserEditPopupComponent } from './user-edit-popup/user-edit-popup.component';
import * as moment from 'moment';

@Component({
  selector: 'app-create-team',
  templateUrl: './create-team.component.html',
  styleUrls: ['./create-team.component.css']
})
export class CreateTeamComponent implements OnInit, AfterViewInit {
  readonly MY_CONSTANT = LabelConstants;

  allUsers: IUserNew[] = [];
  usersSearchList: IUserNew[] = [];
  finalUsersArray: IUserNew[] = [];
  teamHead: string;
  teamNameFormControl = new FormControl('', [Validators.required]);
  adminNameFormControl = new FormControl('', [Validators.required]);
  fetchingData = true;
  userInfo: IValidationResponse;
  uniqueId;
  isCreateTeam: boolean;
  // Drag & Drop lists
  todo = [];
  done = [];

  options: string[] = [];
  filteredOptions: Observable<string[]>;
  showUserRestrictionErrorLabel = false;

  selectedUsers: IUserNew[] = [];
  selectedUsers1: IUserNew[] = [];

  @ViewChild('editUserComponent') editUserComponent: UserEditPopupComponent;
  userData: IUserNew;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private folioHelperService: FolioHelperService,
    private teamService: TeamsService,
    private router: Router,
    private matSnackBar: MatSnackBar,
  ) { }

  ngOnInit() {
    this.fetchingData = false;

    this.filteredOptions = this.adminNameFormControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.userInfo = this.folioHelperService.fetchDataFromLocalStorage(
      AppConstants.PARAM_LOCAL_STORAGE_AUTH_LOGIN_INFO
    );

    this.route.paramMap.subscribe((params: ParamMap) => {
      const id = params.get('teamId');
      this.uniqueId = id;
      /*****  Condittion to display the create team or update team page *********/
      this.isCreateTeam = this.uniqueId === null || this.uniqueId.length <= 0 ? true : false;

    });

    /********* Get Team Details  along with TeamUser Relation  ***********/
    if (!this.isCreateTeam) {
      this.folioHelperService.setSpinnerVisible(true);
      this.teamService.getTeamByIdQuery(this.uniqueId).then( // Get Team Details Based on Id
        succ => {
          const selectedTeam: ITeam = JSON.parse(succ.data['getTeam'].team_details);
          this.selectedUsers = JSON.parse(succ.data['getTeam'].team_mapping);
          this.teamNameFormControl.setValue(selectedTeam.TEAM_NAME ? selectedTeam.TEAM_NAME : '');
          this.adminNameFormControl.setValue(selectedTeam.TEAM_LEAD ? selectedTeam.TEAM_LEAD : '');
          this.fetchUsersList();
        },
        err => {
          console.log('Get team by ID, err: ', err);
          this.folioHelperService.setSpinnerVisible(false);
        }
      );
    } else {
      this.fetchUsersList();
    }
  }


  /************   Getting list of Users by calling a query *********/
  fetchUsersList(): any {
    try {
      this.folioHelperService.setSpinnerVisible(true);
      const usersRawData = this.userService.getAllUsersQuery( // get all Users
        this.userInfo.customerId
      );
      usersRawData
        .then(suc => {
          this.fetchingData = false;
          const usersData = JSON.parse(suc['data']['getUsers'].body);
          this.allUsers = usersData;
          this.allUsers.sort((a, b) => a.USERNAME.localeCompare(b.USERNAME));

          // if user's UNIQUE_ID is NULL, ignore that user.
          this.allUsers = this.allUsers.filter(user => {
            return user.EXTERNAL_ID;
          });
          if (!this.isCreateTeam) {
            this.options = usersData;
            this.mapUsersFromTeam();
            return;
          }
          this.options = usersData;
          this.usersSearchList = this.allUsers;
          // this.todo = this.usersSearchList;
          this.fetchingData = false;
          this.folioHelperService.setSpinnerVisible(false);
        })
        .catch(err => {
          this.folioHelperService.setSpinnerVisible(false);
          console.log('Err: ', err);
        });
    } catch (error) {
      console.log('fetch users error: ', error);
      this.folioHelperService.setSpinnerVisible(false);
    }
  }

  /*********  Map the team to Users based on the data from DB   ********/
  mapUsersFromTeam(): any {
    this.selectedUsers1 = []; // temp variable to load data to the DONE list.
    // data returned from the server & is in the RAW format.
    this.selectedUsers.forEach(selectedUser => {
      this.allUsers.forEach(allUser => {
        if (!allUser.EXTERNAL_ID || !selectedUser.USER_ID) {
          return;
        }
        if (allUser.EXTERNAL_ID === selectedUser.USER_ID) {
          allUser.ACTUAL_END_DATE = null;
          allUser.ACTUAL_START_DATE = null;
          allUser.ADVISOR = null;
          allUser.EXPECTED_END_DATE = null;
          allUser.EXPECTED_START_DATE = null;
          allUser.ACTUAL_END_DATE = selectedUser.ACTUAL_END_DATE;
          allUser.ACTUAL_START_DATE = selectedUser.ACTUAL_START_DATE;
          allUser.ADVISOR = selectedUser.ADVISOR;
          allUser.EXPECTED_END_DATE = selectedUser.EXPECTED_END_DATE;
          allUser.EXPECTED_START_DATE = selectedUser.EXPECTED_START_DATE;
          this.selectedUsers1.push(allUser);
          this.done = this.selectedUsers1;
        } else {
          this.finalUsersArray.push(allUser);
          this.usersSearchList = _.difference(this.finalUsersArray, this.done); // getting the difference of two arrays using Loadash
          this.usersSearchList = Array.from(new Set(this.usersSearchList)); // Removing the duplicates in an array
        }

      });
    });

    this.done = this.selectedUsers1;

    this.folioHelperService.setSpinnerVisible(false);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => {
      if (!option) {
        return;
      }
      return option['USERNAME'].toLowerCase().includes(filterValue);
    });
  }

  ngAfterViewInit() {

  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      if (event.previousContainer.data.length === 1) {
        this.showUserRestrictionErrorLabel = true;
        // return;
      }
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
      const isAddToTeam = event.distance.x > 0;
      if (isAddToTeam) {
        this.userData = this.done[event.currentIndex] as IUserNew;
        this.editUserComponent.editUser(this.userData);
      } else {
        // remove from the team.
      }
    }
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^\s*$/) !== null;
  }

  // Submit Button
  onSubmitFn() {

    if (this.teamNameFormControl.invalid) {
      this.teamNameFormControl.markAsTouched();
      return;
    }
    if (this.isEmptyOrSpaces(this.teamNameFormControl.value)) {
      this.teamNameFormControl.setValue('');
      this.teamNameFormControl.markAsTouched();
      return;
    }
    if (this.adminNameFormControl.invalid) {
      this.adminNameFormControl.markAsTouched();
      return;
    }

    const teamObj: ITeam = {
      TEAM_NAME: this.teamNameFormControl ? this.teamNameFormControl.value.trim() : ' ',
      TEAM_LEAD: this.adminNameFormControl ? this.adminNameFormControl.value.trim() : ' '
    };

    teamObj.teamMembers = this.done; // this.done contains the selected Team Members

    if (this.isCreateTeam) {
      this.createTeam(teamObj);
    } else {
      this.updateTeam();
    }
  }

  applyFilter(value) {
    this.usersSearchList = this.allUsers.filter(mainUser => {
      return !this.done.includes(mainUser);
    });
    this.usersSearchList = this.folioHelperService.filterItems(
      this.usersSearchList,
      value
    );
  }

  exitedData(event) {
    // this.usersSearchList = this.allUsers;
  }

  started($event) {
  }

  /********* Create a Team along with UserToteam Relation  ***********/

  createTeam(teamObj): any {
    this.fetchingData = false;
    this.folioHelperService.setSpinnerVisible(true);

    this.teamService
      .createTeamQuery(teamObj)
      .then(successData => {   // Create Team
        const teamId = successData.data['createTeam']['team_id'];

        this.teamService
          .assignUserToTeamMutation(teamId, teamObj) // create TeamToUser Realtion
          .then(suc => {
            this.router.navigate([`/${localStorage.getItem(AppConstants.PARAM_ROUTE_VALUE_TEAMS)}`]);
          })
          .catch(err => {
            this.folioHelperService.setSpinnerVisible(false);
            console.log('Error: ', err);
          });

        this.folioHelperService.setSpinnerVisible(false);
        window.history.back();
      })
      .catch(err => {
        if (err.name === 'NotAuthorizedException') {
          this.folioHelperService.setSpinnerVisible(false);
          window.history.back();
        }
        console.log('Team Obj err, ', err);
      });

  }

  /********* Update a Team along with TeamToUser Relation  ***********/
  updateTeam(): any {
    this.folioHelperService.setSpinnerVisible(true);
    const teamObj: ITeam = {
      TEAM_ID: this.uniqueId,
      TEAM_NAME: this.teamNameFormControl ? this.teamNameFormControl.value.trim() : ' ',
      TEAM_LEAD: this.adminNameFormControl ? this.adminNameFormControl.value.trim() : ' '
    };
    teamObj.teamMembers = this.done;
    this.teamService.updateTeamMutation(teamObj).then((suc) => { // Update a Team
      this.teamService.updateUserToTeamMutation(this.uniqueId, teamObj).then(() => {
        this.router.navigate([`/${AppConstants.PARAM_ROUTE_VALUE_TEAMS}`]);
        this.folioHelperService.setSpinnerVisible(false);
      }).catch(err => {
        console.log(err);
        this.folioHelperService.setSpinnerVisible(false);
      });
    }).catch((err) => {
      console.log(err);
      this.folioHelperService.setSpinnerVisible(false);
    });
  }

  onCancelButtonClick() {
    window.history.back();
  }

  editUser(userData: IUserNew) {
    this.editUserComponent.editUser(userData);
  }
  updateUser(userData: IUserNew) {
    const userIndex = this.done.findIndex((x: IUserNew) => x.USER_ID === userData.USER_ID);
    if (userIndex !== -1) {
      this.done[userIndex] = userData;
      this.saveUserData(userData);
    }
  }

  saveUserData(user: IUserNew) {
    const data = {
      user_id: user.USER_ID,
      expected_start_date: user.EXPECTED_START_DATE ? moment(user.EXPECTED_START_DATE).format('yyyy-MM-DD') : null,
      expected_end_date: user.EXPECTED_END_DATE ? moment(user.EXPECTED_END_DATE).format('yyyy-MM-DD') : null,
      advisor: user.ADVISOR ? user.ADVISOR : '',
    };
    const actualStartDate = user.ACTUAL_START_DATE ? moment(user.ACTUAL_START_DATE).format('yyyy-MM-DD') : null;
    const actualEndDate = user.ACTUAL_END_DATE ? moment(user.ACTUAL_END_DATE).format('yyyy-MM-DD') : null;

    if (actualStartDate) {
      data['actual_start_date'] = actualStartDate;
    }
    if (actualEndDate) {
      data['actual_end_date'] = actualEndDate;
    }
    this.folioHelperService.setSpinnerVisible(true, 'Updating user data');

    // this.userService.updateUserData(data).then(success => {
    this.editUserComponent.closeKBFromDialog();
    this.folioHelperService.setSpinnerVisible(false);
    // }, failure => {
    //   this.folioHelperService.setSpinnerVisible(false);
    // });
  }
}
